export const emptyTemplate = {
  page: {
    body: {
      container: {
        style: {
          'background-color': '#FFFFFF',
        },
      },
      content: {
        computedStyle: {
          linkColor: '#ff819c',
          messageBackgroundColor: 'transparent',
          messageWidth: '675px',
        },
        style: {
          color: '#000000',
          'font-family': "Arial, 'Helvetica Neue', Helvetica, sans-serif",
        },
      },
      type: 'mailup-bee-page-properties',
      webFonts: [
        {
          fontFamily:
            "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
          name: 'Montserrat',
          url: 'https://fonts.googleapis.com/css?family=Montserrat',
        },
      ],
    },
    description: 'empty-dutchie-template',
    rows: [
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                type: 'mailup-bee-newsletter-modules-heading',
                descriptor: {
                  heading: {
                    title: 'h1',
                    text: '<span class="tinyMce-placeholder">​</span>',
                    style: {
                      color: '#555555',
                      'font-size': '23px',
                      'font-family': 'inherit',
                      'link-color': '#ff819c',
                      'line-height': '120%',
                      'text-align': 'center',
                      direction: 'ltr',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                    },
                  },
                  style: {
                    width: '100%',
                    'text-align': 'center',
                    'padding-top': '0px',
                    'padding-right': '0px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                  },
                  mobileStyle: {},
                },
                uuid: '3951dfe9-6ac9-4c02-86a6-8665df9f07c1',
                locked: false,
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '5px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '5px',
            },
            uuid: 'cb911f58-1e3e-4d35-9717-73e278881987',
          },
        ],
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            color: '#333',
            width: '675px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '4bf4a6fc-45d2-41ae-a96c-1604a93d8e16',
      },
    ],
    template: {
      name: 'template-base',
      type: 'basic',
      version: '2.0.0',
    },
    title: 'empty-dutchie-template',
  },
};
